/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Connectors_Validation_Registry_UrlInputs */



/**
* | output |
* | --- |
* | "Enter an http(s) URL, or leave it empty." |
*
* @param {Partner_Connectors_Validation_Registry_UrlInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_connectors_validation_registry_url = /** @type {((inputs?: Partner_Connectors_Validation_Registry_UrlInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Connectors_Validation_Registry_UrlInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Geben Sie eine http(s)-URL ein oder lassen Sie das Feld leer.")
	return /** @type {LocalizedString} */ ("Enter an http(s) URL, or leave it empty.")
});